import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className"];
import React, { forwardRef } from 'react';
import { CancelIcon } from '@deliveryhero/armor-icons';
import { DropdownBeforeSectionActionContainer, DropdownBeforeSectionClearButton, DropdownBeforeSectionRoot, DropdownBeforeSectionTagsContainer, DropdownBeforeSectionTagsWrapper, DropdownTag } from './style';
import { DROPDOWN_BEFORE_SECTION_CLASS_PREFIX } from './constants';
import { useDropdownBeforeSection } from './utils/useDropdownBeforeSection';
import { useDropdownBeforeSectionClassName } from './utils';
import { DropdownTags } from './DropdownTags';
import { useComponentTheme } from '../../utils/hooks';
export var DropdownBeforeSection = forwardRef(function DropdownBeforeSection(_ref, ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  var theme = useComponentTheme(DROPDOWN_BEFORE_SECTION_CLASS_PREFIX);

  var _useDropdownBeforeSec = useDropdownBeforeSection(props, ref),
      rootProps = _useDropdownBeforeSec.rootProps,
      beforeSectionClearButtonProps = _useDropdownBeforeSec.beforeSectionClearButtonProps,
      getDropdownTagProps = _useDropdownBeforeSec.getDropdownTagProps,
      getDropdownRemainingTagsProps = _useDropdownBeforeSec.getDropdownRemainingTagsProps,
      dropdownBeforeSectionTagsContainerProps = _useDropdownBeforeSec.dropdownBeforeSectionTagsContainerProps,
      dropdownBeforeSectionTagsWrapperProps = _useDropdownBeforeSec.dropdownBeforeSectionTagsWrapperProps,
      dropdownTagsProps = _useDropdownBeforeSec.dropdownTagsProps,
      disabled = _useDropdownBeforeSec.disabled,
      isBeforeSectionRendered = _useDropdownBeforeSec.isBeforeSectionRendered,
      selectedTagsToDisplay = _useDropdownBeforeSec.selectedTagsToDisplay,
      internalOpenTagsCount = _useDropdownBeforeSec.internalOpenTagsCount;

  var classOverride = useDropdownBeforeSectionClassName(DROPDOWN_BEFORE_SECTION_CLASS_PREFIX, className, disabled);

  var renderTags = function renderTags() {
    if (internalOpenTagsCount > 0) {
      var remainingItemsCount = selectedTagsToDisplay.length - internalOpenTagsCount;
      var tagsToRender = selectedTagsToDisplay.slice(0, internalOpenTagsCount);
      var remainingTagsValues = selectedTagsToDisplay.slice(internalOpenTagsCount).map(function (option) {
        return option.value;
      });
      var openTags = React.createElement(DropdownTags, Object.assign({}, dropdownTagsProps, {
        className: className,
        tagsToDisplay: tagsToRender,
        propsFn: getDropdownTagProps
      }));
      var remainingItemsTag = React.createElement(DropdownTag, Object.assign({}, getDropdownRemainingTagsProps(remainingItemsCount, remainingTagsValues), {
        className: classOverride.DropdownTagRemainingItems,
        theme: theme
      }));
      return [openTags, remainingItemsCount > 0 ? remainingItemsTag : null];
    }

    return React.createElement(DropdownTags, Object.assign({}, dropdownTagsProps, {
      className: className,
      tagsToDisplay: selectedTagsToDisplay,
      propsFn: getDropdownTagProps
    }));
  };

  return isBeforeSectionRendered ? React.createElement(DropdownBeforeSectionRoot, Object.assign({}, rootProps, {
    theme: theme,
    className: classOverride.Root
  }), React.createElement(DropdownBeforeSectionTagsContainer, Object.assign({}, dropdownBeforeSectionTagsContainerProps, {
    theme: theme,
    className: classOverride.TagsContainer
  }), React.createElement(DropdownBeforeSectionTagsWrapper, Object.assign({}, dropdownBeforeSectionTagsWrapperProps, {
    theme: theme,
    className: classOverride.TagsWrapper
  }), renderTags())), React.createElement(DropdownBeforeSectionActionContainer, {
    theme: theme,
    className: classOverride.ActionContainer
  }, (selectedTagsToDisplay === null || selectedTagsToDisplay === void 0 ? void 0 : selectedTagsToDisplay.length) ? React.createElement(DropdownBeforeSectionClearButton, Object.assign({}, beforeSectionClearButtonProps, {
    theme: theme,
    className: classOverride.ClearButton
  }), React.createElement(CancelIcon, null)) : null)) : null;
});